export enum HouseRentalMenuEnum {
    overview = 0,
    averageRentUnitWise
}
